
import React, { useEffect, useRef, useState } from "react";
import styles from "./AddProduct.module.css";

import { BiBarcodeReader } from "react-icons/bi";

import toast, { Toaster } from "react-hot-toast";
import { useReactToPrint } from "react-to-print";
import ComponentToPrint from "./BarCode";
import axios from "axios";

// import exportFromJSON from "export-from-json";
import ExportExcel from "../../components/ExportExcel";

import { GiClothes } from "react-icons/gi";

import { motion } from "framer-motion";
import logo from "../../image/manaviea_attire_colorful_logo.png";
import Delete from "../../image/delete.png";
import StylishHoverButton from "../../components/StylishButtons/StylishHoverButtonSearch";
import StylishHoverButtonDelete from "../../components/StylishButtons/StylishHoverButtonDelete";


const Addproducts = (props) => {
  const [PurchaseData, setPurchaseData] = useState([]);
  const [salePrice, setSalePrice] = useState("");

  const [items, setItems] = useState([]);
  const [fixedItems, setFixedItems] = useState([]);
  const [discount, setDiscount] = useState("");
  const [discountPrice, setDiscountPrice] = useState("");
  //categories
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);

  //racks
  const [racks, setRacks] = useState([]);
  const [filteredRacks, setFilteredRacks] = useState([]);

  //product input state:
  const [product_trace_id, setProductTraceId] = useState("");
  const [product_code, setProductCode] = useState("");
  const [name, setName] = useState("");
  const [productCategory, setProductCategory] = useState({
    category_id: "",
    category_name: "",
  });
  const [productRack, setProductRack] = useState({ rack_id: "", rack_no: "" });
  const [model, setModel] = useState("");
  const [type, setType] = useState("");

  const [transaction_id, setTranscation] = useState([]);
  const [transactionId, setTransectionID] = useState("");

  // const [image_blob, setImageBlob] = useState(null);
  const [image, setImage] = useState(null);

  //========product searching:======
  const [productSearchCode, setProductSearchCode] = useState("");
  const [productSearchEmpty, setProductSearchEmpty] = useState(false);

  //ref:
  const productSearchCodeRef = useRef(null);
  const productCategoryRef = useRef(null);
  const productRackRef = useRef(null);
  const [selectedTabID, setSelectedTabID] = useState(null);

  //barcode state:
  const [barcodeProductCode, setBarcodeProductCode] = useState("");
  const [barcodeProductName, setBarcodeProductName] = useState("");
  const [barcodeProductType, setBarcodeProductType] = useState("");
  const [productSize, setProductSize] = useState("");

  //product required field
  const [productCategoryRequired, setProductCategoryRequired] = useState(false);
  const [productRackRequired, setProductRackRequired] = useState(false);
  const [productCodeRequired, setproductCodeRequired] = useState(false);
  const [productNameRequired, setproductNameRequired] = useState(false);

  const [isAdmin, setIsAdmin] = useState("");

  //search state:
  const [productSearchStatus, setProductSearchStatus] = useState(false);
  // axios instance:
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  });


  const userRole = localStorage.getItem("role");
  useEffect(() => {

    if (userRole === "ROLE_ADMIN") {
      setIsAdmin(true);
    }
    else {

      setIsAdmin(false);

    }

    // eslint-disable-next-lin react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = "Product";
    fetchAllProducts();
    fetchAllCategory();
    fetchAllRack();
    fetchPurchaseData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //==========get all products product=============:
  const fetchAllProducts = async () => {
    try {
      const productData = sessionStorage.getItem("productData");
      if (productData) {
        setItems(JSON.parse(productData));
        setFixedItems(JSON.parse(productData));
      } else {
        const response = await axiosInstance.get("/producttraces/getAll");
        setItems(response.data);
        setFixedItems(response.data);
        sessionStorage.setItem("productData", JSON.stringify(response.data));
        // console.log("response.data", response.data);
      }
      sessionStorage.removeItem("productData");
    } catch (error) {
      console.error("Error fetching or storing productTrace Data :", error);
    }
  };

  //================category functionality==========================:
  //get all category:
  const fetchAllCategory = async () => {
    try {
      const { data } = await axiosInstance.get("/category/getAll");
      setCategories(data);
      setFilteredCategories(data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPurchaseData = async () => {
    try {
      const response = await axiosInstance.get(
        `transactionsRouter/getAllTransactionByFiltered?operation_type_id=${2}`
      );
      if (response.data) {
        setPurchaseData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //filter product sale price from purchase data
  // const filterSalePrice =
  //   PurchaseData &&
  //   PurchaseData.find(
  //     (data) => data.ProductTrace?.product_code === product_code
  //   );

  // useEffect(() => {

  //   const salePrice = filterSalePrice?.sale_price;
  //   setSalePrice(salePrice);
  // }, [filterSalePrice]);

  //category delete functionality:

  const deleteTransection = async (event) => {
    // if (!activeRowIndex) {
    //   setActiveRowIndex(true);
    //   toast.warning("Please select at least one row to delete!");
    //   return;
    // }
    if (!product_trace_id) {
      toast.warning("Please select at least one row to delete!");
      return;
    }
    if (event.detail > 1) {
      return;
    }
    try {
      // if (!transaction_id) {
      //   //toast message:
      //   toast.error("Please select at least one row to delete!");
      // } else {

      const confirmDelete = window.confirm(
        "Are you sure you want to delete the selected rows?"
      );
      // if (confirmDelete) {
      // Convert transaction_id to an array if it's not already an array

      if (!confirmDelete) return;


      // Iterate over the array of transaction IDs and delete each one

      const response = await axiosInstance.delete(
        `/producttraces/deleteProductTraceFromAnyPage?product_trace_id=${product_trace_id}`
      );
      if (response.status === 200) {
        toast.dismiss();
        toast.success(`Successfully deleted with ID ${product_trace_id}`);
        const updatedData = items.filter(
          // eslint-disable-next-line eqeqeq
          (item) => item.product_trace_id != product_trace_id
        );
        setItems(updatedData);
        // setActiveRowIndex(false);
      } else {
        console.log(`Error while deleting transaction with ID ${product_trace_id}`);
      }

    } catch (error) {
      console.error(error.message);
    }
  };

  //================racks functionality================================:
  //get all racks:
  const fetchAllRack = async () => {
    try {
      const { data } = await axiosInstance.get("/rack/getAll");
      setRacks(data);
      setFilteredRacks(data);
    } catch (error) {
      console.log(error);
    }
  };

  //=============add product functionality==========================================
  //handle table row:
  const handleClickTableDataShowInputField = (d) => {

   const filterSalePrice =
    PurchaseData &&
    PurchaseData.find(
      (data) => data.product_trace_id === d.product_trace_id
    );
    const salePrice = filterSalePrice?.sale_price;
    setSalePrice(salePrice);

    setSelectedTabID(d.product_trace_id);
    const selectedProduct =
      items &&
      items.length > 0 &&
      items.find((i) => i.product_trace_id === d.product_trace_id);

    if (selectedProduct) {
      console.log(selectedProduct);
      setProductCategory(selectedProduct.Category?.category_id);
      setProductCategory({
        category_id: selectedProduct.Category?.category_id,
        category_name: selectedProduct.Category?.category_name,
      });

      setProductRack({
        rack_id: selectedProduct.Rack?.rack_id,
        rack_no: selectedProduct.Rack?.rack_no,
      });
      setProductTraceId(selectedProduct.product_trace_id);
      setProductCode(selectedProduct.product_code);
      setName(selectedProduct.name);
      setModel(selectedProduct.model);
      setType(selectedProduct.type);
      setProductSize(selectedProduct.Size?.size_name);
      //barcode state
      setBarcodeProductCode(selectedProduct.product_code);
      setBarcodeProductName(selectedProduct.name);
      setBarcodeProductType(selectedProduct.type);
      //image
      if (selectedProduct.image) {
        setImage(selectedProduct.image_blob);
      } else {
        setImage("");
      }
    }
  };

  //handleProductSearch
  const handleProductSearch = () => {
    if (productSearchCode) {
      const filteredproduct = items.filter(
        (item) => item.product_code == productSearchCode
      );
      setItems(filteredproduct);
      setProductSearchStatus(true);
      setProductSearchCode("");
    } else {
      setProductSearchEmpty(true);

      setTimeout(() => {
        setProductSearchEmpty(false);
      }, 2600);
    }
  };

  // handleCleareProductSearch
  const handleCleareProductSearch = () => {
    setProductSearchCode("");
    fetchAllProducts();
    setProductSearchStatus(false);
  };

  const resetProduct = () => {
    setSelectedTabID("");
    setProductTraceId("");
    setProductCode("");
    setName("");
    setModel("");
    setType("");
    setImage(null);

    setProductCategory({
      category_id: "",
      category_name: "",
    });

    // Check if ref exists before setting value
    if (productCategoryRef.current) {
      productCategoryRef.current.value = null;
    }

    setProductRack({ rack_id: "", rack_no: "" });

    // Check if ref exists before setting value
    if (productRackRef.current) {
      productRackRef.current.value = null;
    }

    setProductCategoryRequired(false);
    setProductRackRequired(false);
    setproductCodeRequired(false);
    setproductNameRequired(false);

    resetBarcode();
  };

  const resetBarcode = () => {
    setBarcodeProductCode("");
    setBarcodeProductName("");
    setBarcodeProductType("");
  };

  const resetAll = () => {
    resetProduct();
    resetBarcode();
    setSalePrice("");
  };
  //==========barcode print functionality========:
  const componentRef = useRef();
  const print = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePrint = () => {
    if (product_trace_id) {
      print();
      // resetAll();
    } else {
      toast.error("Please select a product to print Barcode", {
        duration: 700,
      });
    }
  };

  console.log("prodcut category", productCategory);

  return (
    <>

      <div
        className={styles.product_container}
        style={{
          background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
        }}
      >
        <div
          className={styles.header}
          style={{
            color: "#000000",
            fontWeight: "bold",
            fontSize: "2.5vh",
            height: "6vh",
            background: "rgba(249, 176, 191, 0.3)", /* soft pink */
            boxShadow: "0 0 10px rgba(0, 0, 0, 1)", // optional

          }}
        >
          <img
            src={logo}

            style={{
              width: "2vw",
              height: "2vw",
              borderRadius: "50%",
              objectFit: "cover", // ensures image fills the circle nicely
              border: "2px solid #ccc", // optional
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", // optional
            }}
            alt="Logo" />
          <p
            className="heading" >
            Add Product
          </p>

          {/* <img src={lady} alt="" /> */}
        </div>
        <div
          className={styles.addprouct_layer}
          style={{
            background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
          }}
        >
          {/*================ categories start from here================== */}
          <div
            className={styles.Categories_container}
            style={{
              background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
            }}
          >
            <div
              className={styles.card}
              style={{
                background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
              }}
            >
              <div
                className={styles.Categories_div}
                style={{
                  background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
                }}
              >
                <div
                  className={styles.SearchDiv}
                  style={{
                    background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
                  }}
                >
                  <div
                    className={styles.Header_text}
                    style={{
                      background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
                    }}
                  >
                    <h5 className={styles.types_h3}>Category</h5>
                  </div>
                  <div
                    className={styles.search_input_div}
                    style={{
                      background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
                    }}
                  >
                    <input
                      type="text"
                      className={
                        productSearchEmpty
                          ? `${styles.search_input} ${styles.errorBorder}`
                          : `${styles.search_input} `
                      }
                      value={productSearchCode}
                      onChange={(e) => setProductSearchCode(e.target.value)}
                      placeholder="Search product"
                      list="allProducts"
                      ref={productSearchCodeRef}
                    />
                    <datalist id="allProducts">
                      {items.map((product) => (
                        <option
                          key={product.product_code}
                          value={product.product_code}
                        >
                          {product.name}
                        </option>
                      ))}
                    </datalist>
                    <StylishHoverButton 
              onClick=
                    {handleProductSearch}
                    />
                  </div>
                </div>
                <div
                  className={styles.SearchDiv}
                  style={{
                    background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
                  }}
                >
                  <div className={styles.Header_text}>
                    <h5 className={styles.types_h3}>Products</h5>
                  </div>
                  <div className={styles.search_input_div}>
                    <input
                      type="text"
                      className={
                        productSearchEmpty
                          ? `${styles.search_input} ${styles.errorBorder}`
                          : `${styles.search_input} `
                      }
                      value={productSearchCode}
                      onChange={(e) => setProductSearchCode(e.target.value)}
                      placeholder="Search product"
                      list="allProducts"
                      ref={productSearchCodeRef}
                    />
                    <datalist id="allProducts">
                      {items.map((product) => (
                        <option
                          key={product.product_code}
                          value={product.product_code}
                        >
                          {product.name}
                        </option>
                      ))}
                    </datalist>

                    <StylishHoverButton 
                    onClick=
                    {handleProductSearch}
                    />
 
                  </div>
                </div>
                <button
                  className={styles.searchBtn}
                  onClick={handleCleareProductSearch}
                >
                  Show All
                </button>
              </div>
            </div>
          </div>

          {/* ====================product  start from here ========================*/}
          <div
            className={styles.inventory_product_container}
            style={{
              background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
            }}
          >
            <div
              className={styles.card}
              style={{
                background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
              }}
            >
              <div
                className={styles.inventory_product_div}
                style={{
                  background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
                }}
              >


                {/* /===========/table */}
                <div
                  className={styles.product_table}
                  style={{
                    background: "rgba(255, 230, 240, 0.1)", /* light pink with 70% opacity */
                  }}
                >

                  {/* SearchDiv */}
                  {/* <div className={styles.product_table_container}>
                    <table class={styles.tables}>
                      <thead>
                        <tr className={styles.heading_row}>
                          <th>
                            {" "}
                            <div className={styles.t_data}>Code</div>
                          </th>
                          <th>
                            <div className={styles.t_data}>Name</div>
                          </th>
                          <th>
                            <div className={styles.t_data}>Category</div>
                          </th>
                          <th>
                            <div className={styles.t_data}>Type</div>
                          </th>
                          <th>
                            <div className={styles.t_data}>Size</div>
                          </th>
                          <th>
                            <div className={styles.t_data}>Color</div>
                          </th>

                          <th>
                            <div className={styles.t_data}>Rack</div>
                          </th>
                          <th>
                            <div className={styles.t_data}>Image</div>
                          </th>
                        </tr>
                      </thead>

                      <tbody className={styles.tbody}>
                        {items &&
                          items.length > 0 &&
                          items.map((d) => (
                            <tr
                              key={d.product_trace_id}
                              className={`
          ${
            selectedTabID === d.product_trace_id
              ? `${styles.addProduct_tr} ${styles.tab_selected}`
              : styles.addProduct_tr
          }
        `}
                              onClick={() =>
                                handleClickTableDataShowInputField(d)
                              }
                              tabIndex="0"
                            >
                              <td className={styles.addProduct_td}>
                                {d.product_code}
                              </td>
                              <td className={styles.addProduct_td}>{d.name}</td>
                              <td className={styles.addProduct_td}>
                                {d.Category?.category_name || ""}
                              </td>
                              <td className={styles.addProduct_td}>{d.type}</td>
                              <td className={styles.addProduct_td}>
                                {d.Size?.size_name}
                              </td>
                              <td className={styles.addProduct_td}>
                                {d.Color?.color_name}
                              </td>
                              <td className={styles.addProduct_td}>
                                {d.Rack?.rack_no || ""}
                              </td>
                              <td className={styles.addProduct_td}>
                                <img
                                  src={d.Image?.image_url}
                                  alt={d.name}
                                  width={50}
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div> */}
                  <div
                    style={{
                      width: "100%",
                      height: "52vh",
                      background: "#ffffff",
                      borderRadius: "12px",
                      boxShadow: "0 4px 14px rgba(0, 0, 0, 0.08)",
                      overflow: "hidden",
                      display: "flex",
                      flexDirection: "column",
                      background: "rgba(255, 230, 240, 0.2)",
                    }}
                    className={styles.product_table_container}
                  >
                    {/* Table Header */}
                    <div
                      style={{
                        //  background: "linear-gradient(to right, #ff8c42, #ffb347)",
                        background: "#000000",
                        color: "#fff",
                        padding: "12px 0",
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                        fontWeight: 600,
                        letterSpacing: "0.4px",
                        textAlign: "left",
                        display: "flex",
                        width: "100%",
                      }}
                    >
                      {["Code", "Name", "Category", "Type", "Size", "Color", "Rack", "Image"].map(
                        (header, index) => (
                          <div
                            key={index}
                            style={{

                              flex: 1,
                              paddingLeft: "16px",
                              borderRight:
                                index !== 7 ? "1px solid rgba(255,255,255,0.3)" : "none",
                            }}
                          >
                            {header}
                          </div>
                        )
                      )}
                    </div>

                    {/* Table Body (scrollable) */}
                    {/* Table Body (scrollable) */}
                    <div
                      style={{
                        flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#ccc transparent",
                        background: "rgba(255, 230, 240, 0.2)",
                      }}
                    >
                      {items && items.length > 0 ? (
                        items.map((d, i) => (
                          <motion.div
                            key={d.product_trace_id}
                            onClick={() => handleClickTableDataShowInputField(d)}
                            tabIndex="0"
                            initial={{ opacity: 0, y: 15 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: i * 0.05, duration: 0.3 }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              borderBottom: "1px solid #f0f0f0",
                              cursor: "pointer",

                              background: "rgba(255, 230, 240, 0.05)",
                              //  background:  selectedTabID === d.product_trace_id ? "rgba(255, 230, 240, 0.05)" : "rgba(255, 230, 240, 0.05)",
                              transition: "background-color 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              if (selectedTabID !== d.product_trace_id)
                                e.currentTarget.style.backgroundColor = "#fffaf3";
                            }}
                            onMouseLeave={(e) => {
                              if (selectedTabID !== d.product_trace_id)
                                e.currentTarget.style.backgroundColor = "rgba(255, 230, 240, 0.05)";
                            }}
                          >
                            <div style={{ flex: 1, padding: "10px 16px" }}>{d.product_code}</div>
                            <div style={{ flex: 1, padding: "10px 16px" }}>{d.name}</div>
                            <div style={{ flex: 1, padding: "10px 16px" }}>
                              {d.Category?.category_name || ""}
                            </div>
                            <div style={{ flex: 1, padding: "10px 16px" }}>{d.type}</div>
                            <div style={{ flex: 1, padding: "10px 16px" }}>
                              {d.Size?.size_name || ""}
                            </div>
                            <div style={{ flex: 1, padding: "10px 16px" }}>
                              {d.Color?.color_name || ""}
                            </div>
                            <div style={{ flex: 1, padding: "10px 16px" }}>
                              {d.Rack?.rack_no || ""}
                            </div>
                            <div
                              style={{
                                flex: 1,
                                padding: "10px 16px",
                                display: "flex",
                                alignItems: "center",
                                background: "rgba(255, 230, 240, 0.2)",
                              }}
                            >
                              <img
                                src={d.Image?.image_url}
                                alt={d.name}
                                style={{
                                  width: "48px",
                                  height: "48px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                  border: "1px solid #ddd",
                                  transition: "transform 0.2s ease",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                              />
                            </div>
                          </motion.div>
                        ))
                      ) : (
                        <div
                          style={{
                            padding: "40px",
                            textAlign: "center",
                            color: "#888",
                            fontStyle: "italic",
                          }}
                        >
                          No items found.
                        </div>
                      )}
                    </div>

                  </div>


                </div>
                {/* /===========/input starts from here */}
              </div>
            </div>
          </div>

          {/* //barcode footer div start from here */}
          <div
            className={`${styles.cash_Footer} `}

          >
            <div
              className={styles.totalDiv}
              style={{
                background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
              }}
            >
              <div className={styles.Amount}>
                <div className={styles.amountebelDiv}>
                  <label htmlFor="Amount" className={styles.amountLabel}>
                    Product Code
                  </label>
                </div>
                <div className={styles.amountInputDiv}>
                  <input
                    type="text"
                    className={styles.amountInput}
                    value={barcodeProductCode || ""} // Ensure always a string
                    readOnly // Since these are display-only fields
                  />
                </div>
              </div>
              <div className={styles.Amount}>
                <div className={styles.amountebelDiv}>
                  <label htmlFor="Amount" className={styles.amountLabel}>
                    Product Name
                  </label>
                </div>
                <div className={styles.amountInputDiv}>
                  <input
                    type="text"
                    className={styles.amountInput}
                    value={barcodeProductName || ""} // Ensure always a string
                    readOnly
                  />
                </div>
              </div>
              <div className={styles.Amount}>
                <div className={styles.amountebelDiv}>
                  <label htmlFor="Amount" className={styles.amountLabel}>
                    Sale Price
                  </label>
                </div>
                <div className={styles.amountInputDiv}>
                  <input
                    type="text"
                    className={styles.amountInput}
                    value={salePrice || ""} // Ensure always a string
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.totalDiv}
              style={{
                background: "rgba(255, 230, 240, 0.2)", /* light pink with 70% opacity */
              }}
            >
              <div
                className={styles.Amount}
                style={{
                  background: "rgba(255, 230, 240, 0.05)", /* light pink with 70% opacity */
                }}
              >
                <div className={styles.amountebelDiv}>
                  <label htmlFor="Amount" className={styles.amountLabel}>
                    Category
                  </label>
                </div>
                <div className={styles.amountInputDiv}>
                  <input
                    type="text"
                    className={styles.amountInput}
                    value={productCategory.category_name || ""} // Ensure always a string
                    readOnly // Since these are display-only fields
                  />
                </div>
              </div>
              <div className={styles.Amount}>
                <div className={styles.amountebelDiv}>
                  <label htmlFor="Amount" className={styles.amountLabel}>
                    Product Type
                  </label>
                </div>
                <div className={styles.amountInputDiv}>
                  <input
                    type="text"
                    className={styles.amountInput}
                    value={barcodeProductType || ""} // Ensure always a string
                    readOnly
                  />
                </div>
              </div>
              <div className={styles.Amount}>
                <div className={styles.amountebelDiv}>
                  <label htmlFor="Amount" className={styles.amountLabel}>
                    Product Size
                  </label>
                </div>
                <div className={styles.amountInputDiv}>
                  <input
                    type="text"
                    className={styles.amountInput}
                    value={productSize || ""} // Ensure always a string
                    readOnly
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                columnGap:"10vw"
              }}
            >
              <div className={styles.discountInputDiv}>
                <label>Discount</label>
                <input
                  type="number"
                  className={styles.amountInput}
                  value={discount}
                  onChange={(e) => setDiscount(parseFloat(e.target.value))}
                  placeholder="Percentage"
                />
                <span style={{ fontWeight: "bold" }}>%</span>
              </div>

              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                columnGap: "2vw",

              }}>


                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                  <button
                    className={styles.chasOperationBtn}
                    onClick={handlePrint}
                  >
                    <BiBarcodeReader className={styles.barcodeIcon} />
                  </button>
                  Barcode
                </div>

                {isAdmin && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* <button
                      className={styles.chasOperationBtn}
                      onClick={deleteTransection}>
                      <img src={Delete} width={25} alt="" />
                    </button> */}
                    <StylishHoverButtonDelete 
                    onClick={deleteTransection}
                    />

                    Delete
                  </div>
                )


                }
                <div>
                  <ExportExcel excelData={items} fileName={"AddProduct"} />
                </div>
              </div>

            </div>


            <div style={{ display: "none" }}>
              <ComponentToPrint
                ref={componentRef}
                product={barcodeProductName}
                code={barcodeProductCode}
                salePrice={salePrice}
                category={productCategory.category_name}
                type={barcodeProductType}
                size={productSize}
                discount={discount}
              />
            </div>
          </div>
        </div>
        <Toaster />
      </div>
    </>
  );





};

export default Addproducts;
